var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "container", staticClass: "orderDetail container" },
    [
      _c(
        "div",
        { staticClass: "banxin" },
        [
          _vm.orderDetail.state != 5 && _vm.orderDetail.state
            ? _c(
                "div",
                { staticClass: "statusBar" },
                [
                  _vm._l(_vm.statusArr, function(item, index) {
                    return [
                      index !== 0
                        ? _c(
                            "div",
                            {
                              key: index,
                              staticClass: "status_arrow",
                              class:
                                "" +
                                (item.state <= _vm.orderDetail.state
                                  ? "active_status"
                                  : "")
                            },
                            [_c("a-icon", { attrs: { type: "right" } })],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          key: index,
                          staticClass: "status_box",
                          class:
                            "" +
                            (item.state <= _vm.orderDetail.state
                              ? "active_status"
                              : "")
                        },
                        [
                          _c("div", [
                            _c("span", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  index == 0 && _vm.orderDetail.orderFrom == 1
                                    ? "等待卖家收款"
                                    : item.title
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.intro))]),
                          _vm._v(" "),
                          item.state == _vm.orderDetail.state && item.state == 1
                            ? _c("i", { staticClass: "active_status_after" })
                            : _vm._e()
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.orderDetail.state == 5 && _vm.orderDetail.state
            ? _c(
                "div",
                { staticClass: "statusBar" },
                [
                  _vm._l(_vm.statusArr_close, function(item, index) {
                    return [
                      index !== 0
                        ? _c(
                            "div",
                            {
                              key: index,
                              staticClass: "status_arrow",
                              class:
                                "" +
                                (item.state <= _vm.orderDetail.state
                                  ? "active_status"
                                  : "")
                            },
                            [_c("a-icon", { attrs: { type: "right" } })],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          key: index,
                          staticClass: "status_box",
                          class:
                            "" +
                            (item.state <= _vm.orderDetail.state
                              ? "active_status"
                              : "")
                        },
                        [
                          _c("div", [
                            _c("span", [_vm._v(_vm._s(index + 1))]),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.title))])
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(item.intro))]),
                          _vm._v(" "),
                          item.state == _vm.orderDetail.state && item.state == 1
                            ? _c("i", { staticClass: "active_status_after" })
                            : _vm._e()
                        ]
                      )
                    ]
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.orderDetail.state == 1
            ? _c(
                "div",
                {
                  staticClass: "teach-user",
                  style:
                    "" + (_vm.orderDetail.orderFrom == 1 ? "height:61px;" : "")
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "order-detail-bar",
                      style:
                        "" +
                        (_vm.orderDetail.orderFrom == 1
                          ? "border-bottom:none;"
                          : "")
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm._f("paymentModeFormat")(
                              _vm.orderDetail.paymentMode
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", [_vm._v("当前订单状态:")]),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.orderDetail.orderFrom == 1
                              ? "等待卖家收款"
                              : "等待买家付款"
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _vm.orderDetail.orderFrom != 1
                        ? _c("a-icon", { attrs: { type: "clock-circle" } })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderDetail.orderFrom != 1
                        ? _c("div", [
                            _vm.curEndtime.days
                              ? _c("span", { staticClass: "time-nums" }, [
                                  _vm._v(_vm._s(_vm.curEndtime.days))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.curEndtime.days
                              ? _c("span", [_vm._v("天")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.curEndtime.hours
                              ? _c("span", { staticClass: "time-nums" }, [
                                  _vm._v(_vm._s(_vm.curEndtime.hours))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.curEndtime.hours
                              ? _c("span", [_vm._v("时")])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.curEndtime.minutes
                              ? _c("span", { staticClass: "time-nums" }, [
                                  _vm._v(_vm._s(_vm.curEndtime.minutes))
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.curEndtime.minutes
                              ? _c("span", [_vm._v("分后, 系统将自动关闭订单")])
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.orderDetail.orderFrom != 1
                    ? _c("div", { staticClass: "order-detail-content" }, [
                        _c(
                          "div",
                          [
                            _c("span", [_vm._v("1、您可以")]),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.checkPayType }
                              },
                              [_vm._v("付款")]
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v("或者")]),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "primary", ghost: "" },
                                on: { click: _vm.closeOrder }
                              },
                              [_vm._v("取消订单")]
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _vm._m(0),
                        _vm._v(" "),
                        _vm._m(1)
                      ])
                    : _vm._e()
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "card-container" }, [
            _c("div", { staticClass: "order-detail-base" }, [
              _c("div", [
                _c(
                  "p",
                  [
                    _c("a-icon", { attrs: { type: "inbox" } }),
                    _vm._v("收货信息")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v("订单号: " + _vm._s(_vm.orderDetail.orderFormid))
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("收货人: " + _vm._s(_vm.orderDetail.receiveName))
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            收货地址: " +
                      _vm._s(_vm.orderDetail.receiveAdress) +
                      "\n            "
                  ),
                  _c("span", { staticStyle: { "margin-left": "6px" } }, [
                    _vm._v(_vm._s(_vm.orderDetail.address))
                  ])
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("手机: " + _vm._s(_vm.orderDetail.receivePhone))
                ]),
                _vm._v(" "),
                _c("p", [_vm._v("电话: 暂无")])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("a-icon", { attrs: { type: "shop" } }),
                    _vm._v("卖家信息")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [_vm._v("卖家: " + _vm._s(_vm.orderDetail.shopName))]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("店长: " + _vm._s(_vm.orderDetail.chargePersonPhone))
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n            收款账号:\n            " +
                      _vm._s(
                        _vm.orderDetail.bankInfo
                          ? _vm.orderDetail.bankInfo.bankCard
                          : "暂无"
                      ) +
                      "\n          "
                  )
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm._v("电话：" + _vm._s(_vm.orderDetail.chargePersonPhone))
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "p",
                  [
                    _c("a-icon", { attrs: { type: "pay-circle" } }),
                    _vm._v("支付方式")
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    _vm._s(
                      _vm._f("paymentModeFormat")(_vm.orderDetail.paymentMode)
                    )
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticStyle: {
                    border: "0",
                    display: "flex",
                    "flex-direction": "column"
                  }
                },
                [
                  _c(
                    "p",
                    [
                      _c("a-icon", { attrs: { type: "car" } }),
                      _vm._v("物流信息")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.dilevery.length
                    ? _c("div", { staticStyle: { "margin-left": "25px" } }, [
                        _vm._v("\n            暂无物流信息哟~\n          ")
                      ])
                    : _c("div", { staticStyle: { flex: "1 0 0" } }, [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              color: "#f77b0b",
                              "margin-left": "25px",
                              cursor: "pointer"
                            },
                            on: { click: _vm.expressLocation }
                          },
                          [_vm._v("\n              查看详情\n            ")]
                        )
                      ])
                ]
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "product-container" }, [
            _c(
              "div",
              { staticClass: "productInfo" },
              [
                _vm._m(2),
                _vm._v(" "),
                _vm._l(_vm.orderDetail.skus, function(pro, idx) {
                  return _c(
                    "div",
                    {
                      key: idx,
                      staticClass: "bottom",
                      on: {
                        click: function($event) {
                          return _vm.toProductDetail(
                            _vm.orderDetail.shopId,
                            pro
                          )
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "big" }, [
                        _c("img", { attrs: { src: pro.image, alt: "" } }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(pro.productName))])
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "flex-direction": "column" } },
                        _vm._l(pro.values, function(text, ins) {
                          return _c("p", { key: ins }, [_vm._v(_vm._s(text))])
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _vm.orderDetail.state == 1
                        ? _c("div", [_vm._v("待付款")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderDetail.state == 2
                        ? _c("div", [_vm._v("待发货")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderDetail.state == 3
                        ? _c("div", [_vm._v("待收货")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderDetail.state == 4
                        ? _c("div", [_vm._v("已完成")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderDetail.state == 5
                        ? _c("div", [_vm._v("已关闭")])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderDetail.state == 6
                        ? _c("div", [_vm._v("待成团")])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { "flex-direction": "column" } },
                        [_c("span", [_vm._v("x " + _vm._s(pro.number))])]
                      ),
                      _vm._v(" "),
                      pro.originalPrice == 0
                        ? _c(
                            "div",
                            {
                              staticClass: "font-color-FF7 fs-bold",
                              staticStyle: { "flex-direction": "column" }
                            },
                            [_c("span", [_vm._v("¥" + _vm._s(pro.price))])]
                          )
                        : _c("div", { staticClass: "price" }, [
                            _c("span", [_vm._v("¥" + _vm._s(pro.price))]),
                            pro.originalPrice && pro.originalPrice != pro.price
                              ? _c("del", { staticStyle: { color: "#999" } }, [
                                  _vm._v("¥" + _vm._s(pro.originalPrice))
                                ])
                              : _vm._e()
                          ])
                    ]
                  )
                })
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "settlement-container" }, [
            _c("div", { staticClass: "settlement" }, [
              _c("div", { staticClass: "box" }, [
                _c("div", { staticClass: "left" }, [
                  _vm.orderDetail.originalPrice != 0
                    ? _c("p", [
                        _vm._v("\n              商品总价：\n              "),
                        _c(
                          "span",
                          {
                            staticClass: "right",
                            staticStyle: { color: "#b9783f" }
                          },
                          [_vm._v("¥" + _vm._s(_vm.orderDetail.originalPrice))]
                        )
                      ])
                    : _c("p", [
                        _vm._v("\n              商品总价：\n              "),
                        _c(
                          "span",
                          {
                            staticClass: "right",
                            staticStyle: { color: "#b9783f" }
                          },
                          [_vm._v("¥" + _vm._s(_vm.orderDetail.orderPrice))]
                        )
                      ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\n              运费：\n              "),
                    _c("span", { staticClass: "right" }, [
                      _vm._v("¥" + _vm._s(_vm.orderDetail.logisticsPrice))
                    ])
                  ]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v("\n              平台优惠：\n              "),
                    _c("span", { staticClass: "right" }, [
                      _vm._v("-¥" + _vm._s(_vm.orderDetail.discountPrice))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.orderDetail.paymentState == 0
                    ? _c("div", { staticClass: "mar-top-20" }, [
                        _vm._v("\n              需付款：\n              "),
                        _c(
                          "span",
                          {
                            staticClass: "right",
                            staticStyle: { color: "#ff7800" }
                          },
                          [_vm._v("¥" + _vm._s(_vm.orderDetail.price))]
                        ),
                        _vm._v(" "),
                        _vm.orderDetail.originalPrice != 0
                          ? _c(
                              "div",
                              {
                                staticClass: "right",
                                staticStyle: {
                                  display: "block",
                                  "text-decoration": "line-through",
                                  color: "#999 !important"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                ¥" +
                                    _vm._s(_vm.orderDetail.originalPrice) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orderDetail.paymentState == 1 && !_vm.isSchool
                    ? _c("div", { staticClass: "mar-top-20" }, [
                        _vm._v("\n              实付款：\n              "),
                        _c(
                          "span",
                          {
                            staticClass: "right",
                            staticStyle: { color: "#ff7800" }
                          },
                          [_vm._v("¥" + _vm._s(_vm.orderDetail.price))]
                        ),
                        _vm._v(" "),
                        _vm.orderDetail.originalPrice != 0
                          ? _c(
                              "div",
                              {
                                staticClass: "right",
                                staticStyle: {
                                  display: "block",
                                  "text-decoration": "line-through",
                                  color: "#999 !important"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                ¥" +
                                    _vm._s(_vm.orderDetail.originalPrice) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.orderDetail.paymentState == 1 && _vm.isSchool
                    ? _c("div", { staticClass: "mar-top-20" }, [
                        _vm._v("\n              实际需付款：\n              "),
                        _c(
                          "span",
                          {
                            staticClass: "right",
                            staticStyle: { color: "#ff7800" }
                          },
                          [
                            _vm._v(
                              "¥" +
                                _vm._s(
                                  _vm.orderDetail.checkPrice -
                                    _vm.orderDetail.discountPrice
                                )
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "fs13 mar-bot-5",
                            staticStyle: {
                              color: "#999",
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              "padding-right": "4px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                首次支付金额: ¥" +
                                _vm._s(
                                  (
                                    _vm.orderDetail.orderPrice -
                                    _vm.orderDetail.discountPrice
                                  ).toFixed(2)
                                ) +
                                "\n              "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.orderDetail.checkPrice -
                          _vm.orderDetail.orderPrice >
                          0 && _vm.orderDetail.state == 4
                          ? _c(
                              "p",
                              {
                                staticClass: "fs13 mar-bot-5",
                                staticStyle: {
                                  color: "#999",
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "flex-end"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                已追加支付金额:\n                "
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#ff4747" } },
                                  [
                                    _vm._v(
                                      "¥" +
                                        _vm._s(
                                          (
                                            _vm.orderDetail.checkPrice -
                                            _vm.orderDetail.orderPrice
                                          ).toFixed(2)
                                        )
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.orderDetail.checkPrice -
                          _vm.orderDetail.orderPrice <
                          0 && _vm.orderDetail.state == 4
                          ? _c(
                              "p",
                              {
                                staticClass: "fs13 mar-bot-5",
                                staticStyle: {
                                  color: "#999",
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "flex-end"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                已退款金额:\n                "
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { color: "#ff4747" } },
                                  [
                                    _vm._v(
                                      "¥" +
                                        _vm._s(
                                          (
                                            _vm.orderDetail.orderPrice -
                                            _vm.orderDetail.checkPrice
                                          ).toFixed(2)
                                        )
                                    )
                                  ]
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.orderDetail.originalPrice != 0
                          ? _c(
                              "p",
                              {
                                staticClass: "fs13 mar-bot-5",
                                staticStyle: {
                                  "text-decoration": "line-through",
                                  color: "#999",
                                  display: "flex",
                                  "align-items": "center",
                                  "justify-content": "flex-end",
                                  "padding-right": "4px"
                                }
                              },
                              [
                                _vm._v(
                                  "\n                原价: ¥" +
                                    _vm._s(
                                      (
                                        _vm.orderDetail.originalPrice -
                                        _vm.orderDetail.discountPrice
                                      ).toFixed(2)
                                    ) +
                                    "\n              "
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "p",
                          {
                            staticClass: "fs13",
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "flex-end",
                              "padding-right": "4px"
                            }
                          },
                          [
                            _vm._v(
                              "\n                (含运费：¥" +
                                _vm._s(_vm.orderDetail.logisticsPrice) +
                                ")\n              "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "remark-box" }, [
            _c("span", { staticStyle: { color: "#999" } }, [
              _vm._v("订单备注: ")
            ]),
            _vm._v(
              "\n      " +
                _vm._s(_vm.orderDetail.remark || "暂无备注") +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _vm.dilevery.length
            ? [
                _vm.orderDetail.state === 3 || _vm.orderDetail.state === 4
                  ? _c("div", { staticClass: "logistics" }, [
                      _c("p", { staticClass: "fs16 font-color-333" }, [
                        _vm._v("物流信息")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "content" }, [
                        _c("div", { staticClass: "left" }, [
                          _c("img", {
                            attrs: {
                              src: require("../../../static/image/wuliuxin@2x.png"),
                              alt: ""
                            }
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c("p", [_vm._v("发货方式：快递")]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "物流公司：" + _vm._s(_vm.orderDetail.express)
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "运单号码：" +
                                  _vm._s(_vm.orderDetail.deliverFormid)
                              )
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "right" }, [
                          _c(
                            "div",
                            { staticClass: "dilevery" },
                            [
                              _c(
                                "el-timeline",
                                _vm._l(_vm.dilevery, function(item, index) {
                                  return _c(
                                    "el-timeline-item",
                                    {
                                      key: index,
                                      attrs: {
                                        timestamp: item.time,
                                        placement: "top"
                                      }
                                    },
                                    [
                                      _c("div", {
                                        staticStyle: {
                                          "font-size": "14px",
                                          color: "#666"
                                        },
                                        domProps: {
                                          innerHTML: _vm._s(item.reason)
                                        }
                                      })
                                    ]
                                  )
                                }),
                                1
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "提示",
            visible: _vm.closeOrderDialog,
            width: "30%",
            "before-close": _vm.closeOrderBtn
          },
          on: {
            "update:visible": function($event) {
              _vm.closeOrderDialog = $event
            }
          }
        },
        [
          _c("span", [_vm._v("是否取消该订单?")]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.closeOrderDialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.cancelOrder } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.inviteDialog,
            width: "30%",
            "before-close": _vm.inviteDialogClose
          },
          on: {
            "update:visible": function($event) {
              _vm.inviteDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "inviteDialog" }, [
            _c("div", { staticClass: "inviteTit" }, [_vm._v("邀请好友")]),
            _vm._v(" "),
            _c("div", { staticClass: "imgCode" }, [
              _c("img", { attrs: { src: _vm.share.qrcode, alt: "" } })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "weChat",
          attrs: {
            visible: _vm.weChatDialog,
            "before-close": _vm.handleClose,
            width: "25%"
          },
          on: {
            "update:visible": function($event) {
              _vm.weChatDialog = $event
            }
          }
        },
        [
          _c("div", { staticClass: "weChatBox" }, [
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "18px",
                  color: "#000000",
                  padding: "0 20px"
                }
              },
              [
                _vm._v(
                  "\n        请使用具有扫码支付功能的APP完成支付（支持微信、支付宝、云闪付等APP）\n      "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "font-size": "32px",
                  color: "#000000",
                  width: "100%",
                  "text-align": "center"
                }
              },
              [_vm._v("\n        ￥" + _vm._s(_vm.payInfo.money) + "\n      ")]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "qCode" }, [
              _c("img", {
                attrs: {
                  src: "data:image/jpeg;base64," + _vm.payInfo.c2bQrCodeBase64,
                  width: "100%",
                  height: "100%",
                  alt: ""
                }
              })
            ])
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: false,
            maskClosable: false,
            footer: false,
            width: 950
          },
          model: {
            value: _vm.showTeachDialog,
            callback: function($$v) {
              _vm.showTeachDialog = $$v
            },
            expression: "showTeachDialog"
          }
        },
        [
          _c("div", { staticClass: "offlinePayBox" }, [
            _c("div", { staticClass: "offlinePayBox-title" }, [
              _c("span", [_vm._v("操作步骤")]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("请在")]),
                _vm._v(" "),
                _vm.curEndtime.days
                  ? _c("span", { staticClass: "time-nums" }, [
                      _vm._v(_vm._s(_vm.curEndtime.days))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.curEndtime.days ? _c("span", [_vm._v("天")]) : _vm._e(),
                _vm._v(" "),
                _vm.curEndtime.hours
                  ? _c("span", { staticClass: "time-nums" }, [
                      _vm._v(_vm._s(_vm.curEndtime.hours))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.curEndtime.hours ? _c("span", [_vm._v("时")]) : _vm._e(),
                _vm._v(" "),
                _vm.curEndtime.minutes
                  ? _c("span", { staticClass: "time-nums" }, [
                      _vm._v(_vm._s(_vm.curEndtime.minutes))
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.curEndtime.minutes
                  ? _c("span", [_vm._v("分 内完成支付")])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "offlinePayBox-process-bar" }, [
              _c("span", [_vm._v("1")]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("打开手机银行APP/PC网银,或者前往银行柜台")])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "offlinePayBox-process-bar" }, [
              _c("span", [_vm._v("2")]),
              _vm._v(" "),
              _c("div", [
                _c("span", [
                  _vm._v(
                    "\n            用您的银行卡向以下账户进行转账，并备注填写\n            "
                  ),
                  _c("b", { staticStyle: { color: "#ff4747" } }, [
                    _vm._v("付款验证码")
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "offlinePayBox-main-box" }, [
              _c("div", { staticClass: "offlinePayBox-main-box-title" }, [
                _vm._v("收款账户信息")
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("收款户名")]),
                _vm._v(" "),
                _c("span", { attrs: { id: "offlinePayBox-bar1" } }, [
                  _vm._v(_vm._s(_vm.orderDetail.bankInfo.collectionNme))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.copyText(
                          _vm.orderDetail.bankInfo.collectionNme
                        )
                      }
                    }
                  },
                  [_vm._v("复制")]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("收款账号")]),
                _vm._v(" "),
                _c("span", { attrs: { id: "offlinePayBox-bar2" } }, [
                  _vm._v(_vm._s(_vm.orderDetail.bankInfo.bankCard))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.copyText(_vm.orderDetail.bankInfo.bankCard)
                      }
                    }
                  },
                  [_vm._v("复制")]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("收款银行")]),
                _vm._v(" "),
                _c("span", { attrs: { id: "offlinePayBox-bar3" } }, [
                  _vm._v(_vm._s(_vm.orderDetail.bankInfo.bankName))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.copyText(_vm.orderDetail.bankInfo.bankName)
                      }
                    }
                  },
                  [_vm._v("复制")]
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("所在地")]),
                _vm._v(" "),
                _c("span", { attrs: { id: "offlinePayBox-bar4" } }, [
                  _vm._v(_vm._s(_vm.orderDetail.bankInfo.location))
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("span", [_vm._v("付款验证码")]),
                _vm._v(" "),
                _c("span", { attrs: { id: "offlinePayBox-bar5" } }, [
                  _vm._v(_vm._s(_vm.orderDetail.transferCode))
                ]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    on: {
                      click: function($event) {
                        return _vm.copyText(_vm.orderDetail.transferCode)
                      }
                    }
                  },
                  [_vm._v("复制")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "offlinePayBox-process-bar" }, [
              _c("span", [_vm._v("3")]),
              _vm._v(" "),
              _c("div", [
                _c("span", [
                  _vm._v(
                    "系统根据所填写的付款验证码，自动识别到来账，自动核销订单"
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "offlinePayBox-process-bar-small" }, [
              _c("span", [
                _vm._v(
                  "（工作时间同行转账预计2小时，跨行转账T+3天；非工作日均可能有延迟）"
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "offlinePayBox-process-bar-small",
                staticStyle: { color: "#ff4747", "margin-top": "5px" }
              },
              [_c("span", [_vm._v("*请仔细核对以上信息，请勿填写错误")])]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "offlinePayBox-small-info" }, [
              _c("div", { staticClass: "offlinePayBox-small-info-title" }, [
                _c("span", [_vm._v("*")]),
                _vm._v(" "),
                _c("span", [_vm._v("注意事项")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "offlinePayBox-small-info-bar" }, [
                _c("span", [
                  _vm._v(
                    "付款验证码：转账时付款验证码需填写在转账备注里且不得有误，请仔细检查"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "offlinePayBox-small-info-bar" }, [
                _c("span", [_vm._v("转账金额与订单金额务必保持一致")]),
                _vm._v("，不得多转，不得少转，不得分次转账;\n        ")
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "offlinePayBox-small-info-bar" }, [
                _vm._v(
                  "\n          转账的到账时间：建议转账半小时后查看到账情况，工作时间同行转账预计2小时，跨行转账T+3天；非工作日均可能有延迟，以付款方银行规则为准；\n        "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "offlinePayBox-small-info-bar" }, [
                _vm._v(
                  "\n          在转账页面若找不到收款银行，可搜索“民营银行”，再选择\n          "
                ),
                _c("span", [_vm._v("“富滇银行”")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "offlinePayBox-small-info-bar" }, [
                _vm._v(
                  "\n          转账成功后到已买到的货品页面查询订单状态，\n          "
                ),
                _c("span", [_vm._v("订单状态则为付款成功，等待发货。")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "offlinePayBox-small-info-bar" }, [
                _vm._v(
                  "\n          如有其他问题,可联系平台客服咨询,咨询热线400-8816-132\n        "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "offlinePayBox-small-info-title",
                  staticStyle: { "margin-top": "28px", "margin-bottom": "10px" }
                },
                [_vm._v("\n          银行资金流向\n        ")]
              ),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src: require("@/assets/images/money-line.png"),
                  alt: "",
                  srcset: ""
                }
              })
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("2、确认已付款")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("span", [_vm._v("3、如果您不想购买,可以关闭交易")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "top" }, [
      _c("span", { staticClass: "big" }, [_vm._v("商品")]),
      _vm._v(" "),
      _c("span", [_vm._v("商品属性")]),
      _vm._v(" "),
      _c("span", [_vm._v("状态")]),
      _vm._v(" "),
      _c("span", [_vm._v("数量")]),
      _vm._v(" "),
      _c("span", [_vm._v("单价")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-1add3f6b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-1add3f6b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/orderDetail_B2B/index.vue
// module id = null
// module chunks = 